import React, { useMemo } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { MapAPIKey } from "../../Utility/Utility";
import Styles from "./MapContainer.module.css";

function MapContainer({ location }) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: MapAPIKey,
  });

  const center = useMemo(() => {
    return { lat: location.lat, lng: location.lng };
  }, [location]);

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName={Styles.mapContainer}
      //   mapContainerStyle={containerStyle}
      center={center}
      zoom={16}
    >
      <Marker position={center} />
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(MapContainer);
